<template>
  <div id="swagger-ui"></div>
</template>

<script>
import SwaggerUIBundle from 'swagger-ui/dist/swagger-ui-es-bundle';
import SwaggerUIStandalonePreset from 'swagger-ui/dist/swagger-ui-standalone-preset';
import 'swagger-ui/dist/swagger-ui.css';
import ComponentInternalMixin from '../../core/ComponentInternalMixin';

export default {
  name: 'ClicSwaggerInterno',
  inheritAttrs: false,
  mixins: [ComponentInternalMixin],
  computed: {
    urlValue() {
      return this.getProp('url');
    },
    specValue() {
      return this.getProp('spec');
    }
  },
  mounted() {
    this.dataRefresh();
  },
  watch: {
    urlValue() { this.dataRefresh(); },
    specValue() { this.dataRefresh(); }
  },
  methods: {
    dataRefresh() {
      const options = {
        dom_id: '#swagger-ui',
        presets: [
          SwaggerUIBundle.presets.apis,
          SwaggerUIStandalonePreset
        ],
        layout: 'BaseLayout'
      };
      if (this.urlValue) options.url = this.urlValue;
      if (this.specValue) options.spec = this.specValue;
      SwaggerUIBundle(options);
    }
  }
};
</script>
